import { Injectable } from '@angular/core';

const KEY = 'mustChangePassword';
const KEY_PHONE = 'mustChangePasswordPhone';

/**
 * يتحكم بإظهار مودال تغيير كلمة المرور إجبارياً بعد اللوجن عندما يرجع الـ API mustChangePassword: true.
 * الحالة تُخزّن في sessionStorage حتى بعد الـ refresh يبقى المستخدم مجبراً على تغيير الباسورد.
 */
@Injectable({
  providedIn: 'root'
})
export class MustChangePasswordService {

  get required(): boolean {
    return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(KEY) === 'true';
  }

  /** استدعاءها عند mustChangePassword: true من رد اللوجن. يمكن تمرير رقم الهاتف للتحقق من عدم استخدامه في الباسورد. */
  setRequired(phone?: string): void {
    sessionStorage.setItem(KEY, 'true');
    if (phone != null && phone !== '') {
      sessionStorage.setItem(KEY_PHONE, String(phone).trim());
    }
  }

  clear(): void {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY_PHONE);
  }

  /** لاستخدامه في التحقق (مثلاً منع الباسورد أن يحتوي رقم الهاتف). */
  getStoredPhone(): string {
    return typeof sessionStorage !== 'undefined' ? (sessionStorage.getItem(KEY_PHONE) || '') : '';
  }
}
